import { GridColDef } from "@mui/x-data-grid";
import UpdateCompanyPopup from "../../../components/Fleet/UpdateCompanyPopup/UpdateCompanyPopup";
import { Box } from "@mui/material";

export const companyTableColumns: GridColDef[] = [
  {
    field: "rentedAssetsCount",
    headerName: "Rented Assets",
    width: 150,
    sortable: true,
    align: "center",
  },
  { field: "name", headerName: "Company Name", width: 200 },
  { field: "managerName", headerName: "Manager", width: 150 },
  {
    field: "managerPhoneNumber",
    headerName: "Manager Phone",
    width: 150,
  },
  { field: "billingContactName", headerName: "Billing Contact", width: 150 },
  {
    field: "billingContactPhoneNumber",
    headerName: "Billing Phone",
    width: 150,
  },
  { field: "billingEmailAddress", headerName: "Billing Email", width: 200 },
  {
    field: "defaultPaymentMethod",
    headerName: "Payment Method",
    width: 150,
  },
  { field: "taxId", headerName: "Tax ID", width: 120 },
  { field: "dotNumber", headerName: "DOT #", width: 120 },
  { field: "mcNumber", headerName: "MC #", width: 120 },
  { field: "addressLine1", headerName: "Address", width: 200 },
  { field: "addressLine2", headerName: "Address 2", width: 150 },
  { field: "city", headerName: "City", width: 120 },
  { field: "state", headerName: "State", width: 80 },
  { field: "zipCode", headerName: "Zip", width: 100 },

  {
    field: "actions",
    headerName: "",
    width: 100,
    renderCell: (params) => (
      <Box onClick={(e) => e.stopPropagation()}>
        <UpdateCompanyPopup company={params.row} />
      </Box>
    ),
  },
];
